<template>
  <div class="loginIndex" style="background: #ffffff;height: 100%">
    <div class="top">
      <div class="de">
        <div class="noVerification" v-show="isShowv">
          <img src="../../../assets/images/icon_cue.png" alt=""> 您的账号还未进行认证，邀请您进行认证。<span @click="rz">立即认证</span><i class="close" @click="isShowv=false"></i>
        </div>
        <div class="sponsorBtn" @click="fire" v-show="indexData.status==1"><img src="../../../assets/images/icon_add.png">发起签署</div>
      </div>
    </div>
    <div class="middle">
      <div class="middleInner">
        <div class="btns">
          <div class="btn" @click="goList(5)">
            <img src="../../../assets/images/icon_a.png" alt="">
            <span class="num" v-show="indexData.loadMeSignCount>0">{{indexData.loadMeSignCount}}</span>
            <p class="txt">待我签署</p>
          </div>
          <div class="btn" style="margin: 0 110px" @click="goList(4)">
            <img src="../../../assets/images/icon_b.png" alt="">
            <!--<span class="num"></span>-->
            <span class="num" v-show="indexData.loadOtherSignCount>0">{{indexData.loadOtherSignCount}}</span>
            <p class="txt">待他人签署</p>

          </div>
          <div class="btn" @click="goList(2)">
            <img src="../../../assets/images/icon_c.png" alt="">
            <p class="txt">已完成</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottomInner">
        <p class="title">
          <img src="../../../assets/images/icon_-.png" alt="">常见问题
        </p>
        <div class="questionList">
          <div class="item" :class="(index+2)%3==0?'second':''" v-for="(item,index) in indexData.list" @click="goQuestion(item)">{{item.question}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {mapGetters} from 'vuex'
  export default {
      data(){
        return{
          isShowv:false,
          indexData:{}
        }
      },
      created(){
        let _this = this;
        if(!this.gUserInfo.token){
          this.$router.push('/index')
        }else {
          _this.ajpost('/api/account/index',{},function (data) {
            _this.indexData = data.data;
            if(_this.indexData.status ==3){
              _this.isShowv = true
            }
          })
        }
      },
      computed:{
        ...mapGetters([
          "gUserInfo"
        ])
      },
      methods:{
        goList(id){
          this.$router.push('/documentList/'+id)
        },
        goQuestion(item){
          this.$router.push({
            path: `/question/${item.id}`,
          })
        },
        fire(){
          this.$router.push('/fire/add/0')
        },
        rz(){
          this.$router.push({
            path: `/userRz`,
          })
        }
      }
    }
</script>
<style>
  @import "../../../assets/less/loginIndex.css";
</style>



// WEBPACK FOOTER //
// src/components/home/index/loginIndex.vue